import React from "react";
import { NavLink } from "react-router-dom";
import config from "../../config";
import TeleReviewSubNavLink from "../TeleReview/components/TeleReviewSubNavLink";
import "./Monitor.scss";
import { navLinkClick } from "../../shared/Header";

function SubNav({ children, asmpid, hideMainNav, disable = {} }) {
  return (
    <React.Fragment>
      {!config.hideSubNav && (
        <nav className="monitor-sub-nav sub-nav">
          <span className="left-links">
            <DisableableLink
              disabled={hideMainNav}
              to={`/patient/${asmpid}/monitor`}
              exact={true}
              onClick={navLinkClick}
              isActive={(match, location) =>
                match ||
                location.pathname.match(/monitor\/((event-)?history|live)/)
              }
            >
              Monitor
            </DisableableLink>
            <DisableableLink
              disabled={hideMainNav}
              onClick={navLinkClick}
              to={`/patient/${asmpid}/monitor/events`}
            >
              Events
            </DisableableLink>
            <TeleReviewSubNavLink
              disable={hideMainNav || disable.teleReview}
              navLinkClick={navLinkClick}
              asmpid={asmpid}
            />
            <DisableableLink
              disabled={hideMainNav || disable.tools}
              onClick={navLinkClick}
              to={`/patient/${asmpid}/monitor/tools`}
            >
              Tools
            </DisableableLink>
          </span>
          {children ? (
            children
          ) : (
            <span>
              <DisableableLink
                disabled={disable.selectTime}
                to={`/patient/${asmpid}/monitor/history`}
              >
                Select Time
              </DisableableLink>
              <DisableableLink
                disabled={hideMainNav}
                to={`/patient/${asmpid}/monitor/live`}
              >
                Live
              </DisableableLink>
            </span>
          )}
        </nav>
      )}
    </React.Fragment>
  );
}

export default SubNav;

export function DisableableLink(props) {
  const disabled = props.disabled;
  return disabled ? (
    <a href={props.to} className="disabled" onClick={(e) => e.preventDefault()}>
      {props.children}
    </a>
  ) : (
    <NavLink {...props}>{props.children}</NavLink>
  );
}
